import React from 'react'
import DynamicColor from '../common/dynamic-color'

import { COLOR_NAME } from '../../constants'

const Separate = ({ height = 1, color = '', margin = 12 }) => {
    return (
        <DynamicColor
            style={{
                height: height + 'px',
                margin: `${margin}px 0`,
                backgroundColor: COLOR_NAME.BODY_LINE,
            }}
            className={`separate ${color}`}
        />
    )
}

export default Separate
